var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"methods"},[_c('div',{staticClass:"title"},[_vm._v("Convenient repayment methods")]),_vm._v(" "),_c('div',{staticClass:"roll"},[_c('div',{staticClass:"cover_left"}),_vm._v(" "),_c('vue-seamless-scroll',{staticClass:"warp",attrs:{"data":_vm.listData,"class-option":_vm.classOption}},[_c('div',{staticClass:"list"},_vm._l((_vm.listData),function(item,index){return _c('div',{key:index,staticClass:"item"},[_c('img',{attrs:{"src":item.url,"alt":""}})])}),0)]),_vm._v(" "),_c('div',{staticClass:"cover_right"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/repaymentMethods.vue?vue&type=template&id=33836b99&scoped=true
// module id = null
// module chunks = 